<template>
    <div class="container">
        <div v-if="accountActivated === true" class="row">
            <section class="activation__wrapper col-xs-12">
                <img src="../../../assets/images/check-green.svg" style="width: 80px;height: 80px;" />
                <h2 class="title-content --no-border mt-3 mb-3">{{ $t('ACCOUNT_WAS_ACTIVATED') }}</h2>

                <div class="buttons-group">
                    <router-link to="/moje-konto" tag="button" class="app-btn app-btn--big app-btn-primary"
                        >{{ $t('LOGIN_TO_ACCOUNT') }}
                    </router-link>
                </div>
            </section>
        </div>
        <div v-if="accountActivated === false" class="row">
            <section class="activation__wrapper col-xs-12">
                <div class="row my-4">
                    <img src="../../../assets/images/x-red.png" />
                    <span class="title-deactivated ml-3">{{ $t('ACTIVATION_LINK_EXPIRED') }}</span>
                </div>

                <div class="buttons-group">
                    <router-link to="/wyslij-kod-aktywacyjny" tag="button" class="app-btn app-btn--big app-btn-primary"
                        >{{ $t('SEND_ACTIVATION_LINK_AGAIN') }}
                    </router-link>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            token: this.$route.params.token,
            accountActivated: null,
        };
    },
    created() {
        this.$http
            .post('/user/public/registration/activate/', {
                token: this.token,
            })
            .then(() => (this.accountActivated = true))
            .catch(() => (this.accountActivated = false));
    },
};
</script>

<style lang="scss">
h2 {
    text-align: center;
}

.activation__wrapper {
    display: flex;
    flex-flow: column wrap;
    padding: 100px 15px;
    align-items: center;
}

.buttons-group {
    flex-flow: row wrap;

    .app-btn {
        margin: 0 15px 15px;
    }
}

.title-deactivated {
    font-size: 22px;
    font-weight: 700;
}

@media (max-width: 768px) {
    .buttons-group {
        .app-btn {
            margin: 0 auto 15px;
            display: block;
            width: 100%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// activate-account.vue?356babcf